// extracted by mini-css-extract-plugin
module.exports = {"info":"description-module--info--2kcQ4","link":"description-module--link--122Iq"};